export const UserSavesTypes = {
  SHOW_CONVERSATION: 'SHOW_CONVERSATION',
  DETAIL_CONVERSATION: 'DETAIL_CONVERSATION',
  DELETE_CONVERSATION: 'DELETE_CONVERSATION',
  POST_MESSAGE: 'POST_MESSAGE',
}
